// src/components/MultiSeriesPieChart.js
import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

// Datos del gráfico
const data = {
  labels: [
    "Overall Yay", "Overall Nay",
    "Group A Yay", "Group A Nay",
    "Group B Yay", "Group B Nay",
    "Group C Yay", "Group C Nay"
  ],
  datasets: [
    {
      backgroundColor: ['#AAA', '#777'],
      data: [21, 79],
    },
    {
      backgroundColor: ['hsl(0, 100%, 60%)', 'hsl(0, 100%, 35%)'],
      data: [33, 67],
    },
    {
      backgroundColor: ['hsl(100, 100%, 60%)', 'hsl(100, 100%, 35%)'],
      data: [20, 80],
    },
    {
      backgroundColor: ['hsl(180, 100%, 60%)', 'hsl(180, 100%, 35%)'],
      data: [10, 90],
    }
  ],
};

// Opciones con leyenda personalizada
const options = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
      labels: {
        generateLabels(chart) {
          // Lógica para combinar todos los datasets en una sola leyenda
          const original = ChartJS.overrides.pie.plugins.legend.labels.generateLabels;
          const labelsOriginal = original.call(this, chart);

          let datasetColors = chart.data.datasets.map(e => e.backgroundColor).flat();

          labelsOriginal.forEach(label => {
            label.datasetIndex = Math.floor(label.index / 2);
            label.hidden = !chart.isDatasetVisible(label.datasetIndex);
            label.fillStyle = datasetColors[label.index];
          });

          return labelsOriginal;
        }
      },
      onClick: (e, legendItem, legend) => {
        const chart = legend.chart;
        const datasetIndex = legendItem.datasetIndex;
        const meta = chart.getDatasetMeta(datasetIndex);
        meta.hidden = chart.isDatasetVisible(datasetIndex);
        chart.update();
      }
    },
    tooltip: {
      callbacks: {
        title(context) {
          const labelIndex = (context[0].datasetIndex * 2) + context[0].dataIndex;
          return context[0].chart.data.labels[labelIndex] + ': ' + context[0].formattedValue;
        }
      }
    }
  }
};

const Chart7 = () => {
  return <Pie data={data} options={options} />;
};

export default Chart7;
